export type AvatarSize = "small" | "medium" | "large";

export const DEFAULT_AVATAR_SIZE: AvatarSize = "small";

export function getAvatarCacheKey(id: string, size: AvatarSize = DEFAULT_AVATAR_SIZE): string {
  return `${id}:${size}`;
}
